import { getCustomStyles } from "Config/Config";
import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const EcoleadAccordion = ({
  validation = {},
  setValidation,
  meetingTypeList = [],
  previousRelationList = [],
  possibleServiceList = [],
  ecoleadsshowoptions,
  shareLeadsValue = null,
  shareSelectionHandler,
  searching = "",
  setsearching,
  interviewCost = "",
  setinterviewCost,
  comments = "",
  setcomments,
  opportunityTitle = "",
  setopportunityTitle,
  responsibility = "",
  setresponsibility,
  meetingTypeValue = null,
  meetingTypeSelectionHandler,
  relationshipValue = null,
  relationshipSelectionHandler,
  possibleServiceValue = null,
  serviceSelectionHandler,
  isFieldAllowed = () => true,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseTen"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseTen"
        >
          {t("Ecoleads")}
        </button>
      </h3>

      <div
        id="panelsStayOpen-collapseTen"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          {/* Show this lead with */}
          {isFieldAllowed("shareleads") && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold mb-2">
                {t("Show this lead with")}
              </label>
              <Select
                isClearable
                className="w-100"
                placeholder={t("Select share this leads with")}
                options={ecoleadsshowoptions}
                value={shareLeadsValue}
                onChange={(val) => {
                  shareSelectionHandler(val);
                  setValidation((prevState) => ({
                    ...prevState,
                    searchingWarning: false,
                    costWarning: false,
                    commentWarning: false,
                    responsibilityWarning: false,
                    meetingTypeWarning: false,
                    relationshipWarning: false,
                    serviceTypeWarning: false,
                    opportunityTitleWarning: false,
                  }));
                }}
                styles={getCustomStyles()}
              />
            </div>
          )}

          {/* Searching & Cost row */}
          {(isFieldAllowed("searching") ||
            isFieldAllowed("costofinterview")) && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <div className="row">
                {isFieldAllowed("searching") && (
                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Searching")}
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm border border-gray-300 shadow-none"
                      placeholder={t("Add searching")}
                      value={searching}
                      onChange={(e) => {
                        setsearching(e.target.value);
                        setValidation((prevState) => ({
                          ...prevState,
                          searchingWarning: false,
                        }));
                      }}
                    />
                    {validation.searchingWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please enter a searching")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {isFieldAllowed("costofinterview") && (
                  <div className="col-lg-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Cost of interview")}
                    </label>
                    <input
                      type="number"
                      className="form-control fs-sm border border-gray-300 shadow-none"
                      placeholder={t("Enter cost")}
                      value={interviewCost}
                      onChange={(e) => {
                        if (e.target.value >= 0) {
                          setinterviewCost(e.target.value);
                        }

                        setValidation((prevState) => ({
                          ...prevState,
                          costWarning: false,
                        }));
                      }}
                    />
                    {validation.costWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please enter a interview cost")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Comments */}
          {isFieldAllowed("comments") && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold mb-2">
                {t("Comments of Notes")}
              </label>
              <textarea
                name="resumeSummery"
                id="resumeSummery"
                cols="30"
                rows="4"
                className="form-control fs-sm border border-gray-300 shadow-none"
                placeholder={t("Comments of Notes")}
                value={comments}
                onChange={(e) => {
                  setcomments(e.target.value);
                  setValidation((prevState) => ({
                    ...prevState,
                    commentWarning: false,
                  }));
                }}
              ></textarea>
              {validation.commentWarning && (
                <div className="error-message mt-2">
                  <p className="d-flex align-items-center gap-1 text-danger mb-0">
                    <span className="material-symbols-outlined">warning</span>
                    <span>{t("Please enter a comments")}!</span>
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Responsibility */}
          {isFieldAllowed("responsibility") && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label className="d-block fs-sm fw-semibold mb-2">
                {t("Responsibility")}
              </label>
              <textarea
                cols="30"
                rows="4"
                className="form-control fs-sm border border-gray-300 shadow-none"
                placeholder={t("Responsibility")}
                value={responsibility}
                onChange={(e) => {
                  setresponsibility(e.target.value);
                  setValidation((prevState) => ({
                    ...prevState,
                    responsibilityWarning: false,
                  }));
                }}
              ></textarea>
              {validation.responsibilityWarning && (
                <div className="error-message mt-2">
                  <p className="d-flex align-items-center gap-1 text-danger mb-0">
                    <span className="material-symbols-outlined">warning</span>
                    <span>{t("Please enter a responsibility")}!</span>
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Meeting Type & Previous Relationship (same row) */}
          {(isFieldAllowed("meetingtypeids") ||
            isFieldAllowed("previousrelationshipids")) && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <div className="row">
                {isFieldAllowed("meetingtypeids") && (
                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Meeting Type")}
                    </label>
                    <Select
                      className="w-100"
                      placeholder={t("Select Meeting Type")}
                      options={meetingTypeList}
                      isMulti
                      value={meetingTypeValue}
                      onChange={(val) => {
                        meetingTypeSelectionHandler(val);
                        setValidation((prevState) => ({
                          ...prevState,
                          meetingTypeWarning: false,
                        }));
                      }}
                      styles={getCustomStyles()}
                    />
                    {validation.meetingTypeWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please select meeting type")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {isFieldAllowed("previousrelationshipids") && (
                  <div className="col-lg-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Previous Relationship")}
                    </label>
                    <Select
                      className="w-100"
                      placeholder={t("Select Relationship")}
                      options={previousRelationList}
                      isMulti
                      value={relationshipValue}
                      onChange={(val) => {
                        relationshipSelectionHandler(val);
                        setValidation((prevState) => ({
                          ...prevState,
                          relationshipWarning: false,
                        }));
                      }}
                      styles={getCustomStyles()}
                    />
                    {validation.relationshipWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please select relationship")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Possible Services & Opportunity Title (same row) */}
          {(isFieldAllowed("possibleservices") ||
            isFieldAllowed("opportunitytitle")) && (
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <div className="row">
                {isFieldAllowed("possibleservices") && (
                  <div className="col-lg-6 mb-3 mb-lg-0">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Possible Services")}
                    </label>
                    <Select
                      className="w-100"
                      placeholder={t("Select Services")}
                      options={possibleServiceList}
                      isMulti
                      value={possibleServiceValue}
                      onChange={(val) => {
                        serviceSelectionHandler(val);
                        setValidation((prevState) => ({
                          ...prevState,
                          serviceTypeWarning: false,
                        }));
                      }}
                      styles={getCustomStyles()}
                    />
                    {validation.serviceTypeWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please select service type")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {isFieldAllowed("opportunitytitle") && (
                  <div className="col-lg-6">
                    <label className="d-block fs-sm fw-semibold mb-2">
                      {t("Opportunity Title")}
                    </label>
                    <input
                      type="text"
                      className="form-control fs-sm border border-gray-300 shadow-none"
                      placeholder={t("Enter Opportunity Title")}
                      value={opportunityTitle}
                      onChange={(e) => {
                        setopportunityTitle(e.target.value);
                        setValidation((prevState) => ({
                          ...prevState,
                          opportunityTitleWarning: false,
                        }));
                      }}
                    />
                    {validation.opportunityTitleWarning && (
                      <div className="error-message mt-2">
                        <p className="d-flex align-items-center gap-1 text-danger mb-0">
                          <span className="material-symbols-outlined">
                            warning
                          </span>
                          <span>{t("Please enter opportunity title")}!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EcoleadAccordion;
